import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loader from '../../components/loader';
import moment from 'moment';

import {
  fetchFxSnapshot,
} from '../../actions';

class ChartTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLarge: true,
      fxSnapDayLoading: true,
      fxSnapWeekLoading: true,
    };
    this.assetPriceChart = this.assetPriceChart.bind(this);
    this.valueDifference = this.valueDifference.bind(this);
    this.setTableLayout = this.setTableLayout.bind(this);
  }

  componentDidMount() {
    const { dispatch, userCurrencyHandle } = this.props;
    this.setTableLayout();
    window.addEventListener('resize', this.setTableLayout);
    const dataDay = {
      period: '24hrs',
    };
    const dataWeek = {
      period: '7days',
    };
    dispatch(fetchFxSnapshot(dataDay))
      .then((res) => {
        if (res.type === 'FETCH_FX_SNAPSHOT_DAY_SUCCESS') {
          this.setState({ fxSnapDayLoading: false });
        }
      });
    dispatch(fetchFxSnapshot(dataWeek))
      .then((res) => {
        if (res.type === 'FETCH_FX_SNAPSHOT_WEEK_SUCCESS') {
          this.setState({ fxSnapWeekLoading: false });
        }
      });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setTableLayout);
  }

  setTableLayout() {
    const { isLarge } = this.state;
    if ((window.innerWidth > 780) && !isLarge) {
      this.setState({ isLarge: window.innerWidth > 780 });
    }
    if ((window.innerWidth <= 780) && isLarge) {
      this.setState({ isLarge: window.innerWidth > 780 });
    }
  }

  assetPriceChart(asset, currency) {
    let isMetal;
    let useAsset;
    let useCurrency;

    switch (currency) {
      case 'EURCENT':
        useCurrency = 'EUR';
        break;
      case 'CENT':
        useCurrency = 'USD';
        break;
      default:
        useCurrency = 'EUR';
        break;
    }
    switch (asset) {
      case 'GOLD':
        isMetal = true;
        useAsset = 'XAU';
        break;
      case 'SILV':
        isMetal = true;
        useAsset = 'XAG';
        break;
      case 'PALL':
        isMetal = true;
        useAsset = 'XPD';
        break;
      case 'PLAT':
        isMetal = true;
        useAsset = 'XPT';
        break;
      default:
        isMetal = false;
        useAsset = asset;
        break;
    }
    if (isMetal) {
      window.open('https://www.tradingview.com/symbols/' + useAsset + useCurrency + 'G', '_blank');
    } else {
      window.open('https://www.tradingview.com/symbols/' + useAsset + useCurrency + '/?exchange=KRAKEN', '_blank');
    }
  }

  valueDifference(type, value, handle) {
    const { percentChange, fxSnapshot, fxSnapDay, fxSnapWeek } = this.props;
    const newVal = Number(value / 100);
    if (type === 'LOADING') {
      // return percentChange(type, newVal, newVal);
      return (
        <span style={{opacity: '0.5'}}>&mdash;</span>
      );
    }
    let oldValDates;
    let oldValItem;
    let oldVal = newVal;

    if ((fxSnapDay && fxSnapDay.length) && (fxSnapWeek && fxSnapWeek.length)) {
      if (type === 'DAY') {
        if (fxSnapDay) {
          oldValDates = fxSnapDay;
        }
      }
      if (type === 'WEEK') {
        if (fxSnapWeek) {
          oldValDates = fxSnapWeek;
        }
      }
      if (oldValDates && oldValDates.length) {
        oldValItem = oldValDates.find(function (item) {
          if (item && item.handle) {
            return item.handle === handle;
          }
        });
      }
      if (oldValItem && oldValItem.value) {
        oldVal = Number(oldValItem.value / 100);
      }
    }
    return percentChange(type, newVal, oldVal);
  }

  render() {
    const { user, balance, AssetOrder, showAsset, currencySign, toLocaleFixed, humName, eurTstValue, eurEthLoading } = this.props;
    const { isLarge, fxSnapDayLoading, fxSnapWeekLoading } = this.state;

    let userCurrencyHandle;
    if (user && user.me && user.me.defaults && user.me.defaults.currencyHandle) {
      userCurrencyHandle = user.me.defaults.currencyHandle;
    }

    let balanceSettled;

    if (balance && balance.data && balance.data.length) {
      balanceSettled = balance.data.filter(function(item) {
        return item.type === 'SETTLED';
      });
    }

    let orderedSettled;
    if (balanceSettled) {
      orderedSettled = balanceSettled.slice(0).sort(function (a, b) {
        let aIndex = AssetOrder.indexOf(a.handle);
        let bIndex = AssetOrder.indexOf(b.handle);
        if (aIndex == -1) {
          aIndex = AssetOrder.length + 1;
        }
        if (bIndex == -1) {
          bIndex = AssetOrder.length + 1;
        }
        const sorted = aIndex - bIndex;
        return sorted;
      });
    }

    const tableLoop = orderedSettled && orderedSettled.map((value, index) => {
      let enabledFxData;
      if (balance && balance.fxData && balance.fxData.length) {
        enabledFxData = balance.fxData.filter(() => showAsset(value.handle));
      }
      let assetFx;
      let useHandle = '';
      if (value.handle) {
        useHandle = humName(value.handle);
        if (enabledFxData && enabledFxData.length) {
          assetFx = enabledFxData.find((item) => item.handle === value.handle);
        }
        let humPrice = '';
        let price = '';
        if (assetFx && assetFx.value) {
          humPrice = toLocaleFixed((assetFx.value / 100), 2);
          price = assetFx.value;
        }

        let usePrice;
        let useTotal;
        if (humPrice) {
          usePrice = humPrice;
        }
        if (value.total) {
          useTotal = value.total;
        }

        // // TODO REMOVE ONCE TST CALCULATED ON API
        // if (value.handle === 'TST') {
        //   if (eurEthLoading) {
        //     if (isLarge) {
        //       return (
        //         <tr key={index}>
        //           <td colSpan="6" style={{textALign: 'center'}}>
        //             <Loader small />
        //           </td>
        //         </tr>
        //       );
        //     }
        //     return (
        //       <div className="cell panel small-12 medium-12 large-12 l-mob-table">
        //         <Loader logo />
        //       </div>
        //     );
        //   }
        //   usePrice = toLocaleFixed(eurTstValue(1), 2);
        // }

        if (showAsset(value.handle)) {
          if (isLarge) {
            return (
              <tr key={index}>
                <td className="pt-con">
                  <div className="pt-coin">
                    <div
                      className={'balances-coin ' + useHandle.replace(/\s/g, "-").toLowerCase()}
                      onClick={() => this.assetPriceChart(value.handle)}
                    >
                      <img alt={useHandle} src={process.env.REACT_APP_CDN + '/assets/icons/assets/' + useHandle.replace(/\s/g, "-").toLowerCase() + '.svg'} />
                    </div>
                    <span>{useHandle}</span>
                  </div>
                </td>
                <td>
                  {currencySign(value.currencyHandle || userCurrencyHandle)}
                  {usePrice}
                </td>

                {/* TODO REMOVE ONCE TST CALCULATED ON API */}
                {/* {value.handle === 'TST' ? (
                  <>
                    <td><span style={{opacity: '0.5'}}>&mdash;</span></td>
                    <td><span style={{opacity: '0.5'}}>&mdash;</span></td>
                  </>
                ) : (
                  <>
                    {fxSnapDayLoading ? (
                      <td>{this.valueDifference('LOADING', price, value.handle)}</td>
                    ) : (
                      <td>{this.valueDifference('DAY', price, value.handle)}</td>
                    )}
                    {fxSnapWeekLoading ? (
                      <td>{this.valueDifference('LOADING', price, value.handle)}</td>
                    ) : (
                      <td>{this.valueDifference('WEEK', price, value.handle)}</td>
                    )}
                  </>
                )} */}
                {fxSnapDayLoading ? (
                  <td>{this.valueDifference('LOADING', price, value.handle)}</td>
                ) : (
                  <td>{this.valueDifference('DAY', price, value.handle)}</td>
                )}
                {fxSnapWeekLoading ? (
                  <td>{this.valueDifference('LOADING', price, value.handle)}</td>
                ) : (
                  <td>{this.valueDifference('WEEK', price, value.handle)}</td>
                )}
                <td>{value.quantity}</td>
                <td>
                  {currencySign(value.currencyHandle || userCurrencyHandle)}

                  {/* TODO REMOVE ONCE TST CALCULATED ON API */}
                  {/* {value.handle === 'TST' ? (
                    <>
                      {eurEthLoading ? (
                        <Loader small />
                      ) : (
                        toLocaleFixed((value.quantity * eurTstValue(1)), 2)
                      )}
                    </>
                  ) : (
                    <>
                      { value.total ? (
                        toLocaleFixed((value.total / 100), 2)
                      ) : (
                        Number('0').toFixed(2)
                      )}
                    </>
                  )} */}
                  { value.total ? (
                    toLocaleFixed((value.total / 100), 2)
                  ) : (
                    Number('0').toFixed(2)
                  )}
                </td>
              </tr>
            );
          }
          return (
            <div className="cell panel small-12 medium-12 large-12 l-mob-table">
              <div className="lmt-head">
                <div
                  className={'balances-coin ' + useHandle.replace(/\s/g, "-").toLowerCase()}
                  onClick={() => this.assetPriceChart(value.handle)}
                >
                  <img alt={useHandle} src={process.env.REACT_APP_CDN + '/assets/icons/assets/' + useHandle.replace(/\s/g, "-").toLowerCase() + '.svg'} />
                </div>
                <h2>{useHandle}</h2>
              </div>
              <table>
                <tbody>
                  <tr>
                    <td>Price</td>
                    <td>
                      {currencySign(value.currencyHandle || userCurrencyHandle)}
                      {usePrice}
                    </td>
                  </tr>
                  <tr>
                    <td>24h</td>
                    {fxSnapDayLoading ? (
                      <td>{this.valueDifference('LOADING', price, value.handle)}</td>
                    ) : (
                      <td>{this.valueDifference('DAY', price, value.handle)}</td>
                    )}
                  </tr>
                  <tr>
                    <td>7d</td>
                    {fxSnapWeekLoading ? (
                      <td>{this.valueDifference('LOADING', price, value.handle)}</td>
                    ) : (
                      <td>{this.valueDifference('WEEK', price, value.handle)}</td>
                    )}
                  </tr>
                  <tr>
                    <td>Holdings</td>
                    <td>{value.quantity}</td>
                  </tr>
                  <tr>
                    <td>Total Value</td>
                    <td>
                      {currencySign(value.currencyHandle || userCurrencyHandle)}
                      { value.total ? (
                        toLocaleFixed((value.total / 100), 2)
                      ) : (
                        Number('0').toFixed(2)
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          );
        }
      }
    });

    const tableReady = tableLoop;

    if (tableReady) {
      if (isLarge) {
        return (
          <>
            <div className="pt-con">
              <table>
                <thead>
                  <tr>
                    <th style={{ textAlign: 'left' }}>Coin / Token</th>
                    <th>Price</th>
                    <th>24h</th>
                    <th>7d</th>
                    <th>Holdings</th>
                    <th>Total Value</th>
                  </tr>
                </thead>
                {balanceSettled && balanceSettled.length ? (
                  <tbody>
                    {tableLoop}
                  </tbody>
                ) : (
                  null
                )}
              </table>
            </div>
            {balanceSettled && balanceSettled.length ? (
              null
            ) : (
              <div>
                <h3 style={{ textAlign: 'center' }}>No Data</h3>
              </div>
            )}
          </>
        );
      }
      return (
        <div className="pt-con grid-x">
          {balanceSettled && balanceSettled.length ? (
            tableLoop
          ) : (
            null
          )}
        </div>
      );
    }

    return (
      <div className="center-loader">
        <Loader logo />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  errors: state.user.errors,
  balance: state.balance.balance,
  dailyPrices: state.balance.daily,
  fxSnapDay: state.balance.fxSnapDay,
  fxSnapWeek: state.balance.fxSnapWeek,
  dailyLedger: state.ledger.daily,
});

export default connect(mapStateToProps)(ChartTable);
